import type { CollectionViewParams, CollectionViewParamsConfig } from './types';

export const getDefaultCollectionViewParams = <Filters>(
  config: CollectionViewParamsConfig<Filters>,
): CollectionViewParams<Filters> => ({
  filters: config.defaultFilters ?? ({} as Filters),
  sort:
    config.defaultSortBy && config.defaultSortOrder
      ? { columnId: config.defaultSortBy, direction: config.defaultSortOrder }
      : null,
});
